import endpoint from '../../features/endPoints/ecommEndpoints';
import { client } from '../base/ecommClient';


const getAppointmentsClient = (zipcode) => {

  const requestBody = mapRequest();
  return client.get(
    endpoint.getAppointments(zipcode),
    requestBody,
    mapResponse,
    mapError
  );
};

export const getShowScheduleClient = () => {
  const requestBody = mapRequest();
  return client.get(
    endpoint.getShowSchedule(),
    requestBody,
    mapResponse,
    mapError
  );
};

//map body to request body as per API
const mapRequest = () => {
  var bodyData = {};

  return bodyData;
};

//map response to object needed by React view
const mapResponse = (response) => {
  return response;
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};

export default getAppointmentsClient;